import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import instance from '@src/api/axiosInstance';

export interface SystemPromptVersion {
  id: number;
  system_prompt_id: number;
  prompt: string;
  is_active: boolean;
  product: string;
  created_at: string;
  created_by: number;
  version_notes: string;
}

export const useGetVersions = ({ promptId = null, enabled = false }) => {
  return useQuery<SystemPromptVersion[], AxiosError>({
    queryKey: ['system-prompt-versions', promptId],
    queryFn: async () => {
      if (!promptId) {
        throw new Error('Prompt ID is required');
      }
      const response = await instance.get(`/nexa/system-prompt/${promptId}/versions`);
      return response.data;
    },
    enabled: enabled && !!promptId,
    staleTime: 1 * 60 * 1000, // 1m
    refetchOnWindowFocus: false,
    retry: false,
  });
};
